import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { withLocalize } from 'locales';

import PhoneAuthForm from 'containers/PhoneAuthForm';
import Panel from 'components/Helpers/Panel';

import messages from './messages';

class Form extends React.Component {
  static propTypes = {
    localize: PropTypes.func.isRequired,
  };

  render() {
    const { localize } = this.props;
    return (
      <Panel id="add_form">
        <p className="h3">
          <FormattedMessage
            id="sell_auto.form_phone.create.step1"
            defaultMessage="Крок 1"
            description=""
          />
        </p>
        <p>
          <FormattedMessage
            id="sell_auto.form_phone.create.heading3"
            defaultMessage="Вкажіть Ваш контактний номер телефону"
            description=""
          />
        </p>
        <PhoneAuthForm next="/add" ctaTitle={localize('Продовжити')} />
      </Panel>
    );
  }
}

export default withLocalize(messages)(Form);
